import { initializeUpdater } from "./utils/auto-initialize";

initializeUpdater();
